export const ALL_STATUS = {
  OVERDUE_TODAY: 'OVERDUE_TODAY',
  OVERDUE: 'OVERDUE',
  TODAY: 'TODAY',
  TOMORROW: 'TOMORROW',
  THIS_WEEK: 'THIS_WEEK',
  THIS_MONTH: 'THIS_MONTH',
  CUSTOMIZE: 'CUSTOMIZE',
  ALL: 'ALL'
};



// WEBPACK FOOTER //
// ./src/views/Task/flow/config.js